import { createFileRoute } from "@tanstack/react-router";
import DealerManagement from "@/pages/admin/DealerManagement";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/dealer-management/")({
  head: () => routeHead("/admin/dealer-management/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealerManagement />
  );
}
